import Header from '../components/Header';
import Card from '../components/Card';
import { useSelector } from 'react-redux';
import NoData from '../components/NoData';

const MyDeck = () => {
  const message = 'My Deck'
  const { deck } = useSelector((state) => state.cards)
  
  return (
    <>
      <div
        className="
          flex
          flex-col
          min-h-screen
          items-center"
      >
        <Header msg={message} />
        <section
          className="
            relative
            w-full
            bg-transparent"
        >
          <section className="text-gray-600 body-font">
            <div className="container z-20 px-5 py-8 mx-auto ">
              <div className="flex flex-wrap -m-4 z-20">
                { deck.length > 0 ?
                  deck.map(card => {
                  return (<Card isHome={false} key={ card.id } card={ card }/>)
                }) :  <NoData />}
              </div>
            </div>
          </section>
        </section>
      </div>
    </>
  )
}

export default MyDeck